import { useSelector } from 'react-redux';
import { MagnifyingGlassIcon } from '@rsos/assets/icons';
import { ActionBarItem } from '../ActionBarItem';

const SearchActionBarItem = ({ onClick, shouldHide }) => {
  const isCollapsed = useSelector(state => state.queue?.isQueueCollapsed);

  return (
    <ActionBarItem
      shouldRender={isCollapsed && !shouldHide}
      tooltipText="Search"
      onClick={onClick}
    >
      <MagnifyingGlassIcon height={16} width={16} />
    </ActionBarItem>
  );
};

export default SearchActionBarItem;
